/**
 * Whether a stored legal form is one, shared by every surface that shows,
 * exports or hands it to a model.
 *
 * This file is consumed by `@shaarp/ui`. `@shaarp/api` cannot import a runtime
 * value from this package (its barrel re-exports a directory, which Node
 * refuses to resolve from the API's CommonJS build), so it keeps a mirrored
 * copy in `api/src/common/utils/company-legal-form.ts`, held to this one by
 * `api/src/common/utils/company-legal-form-parity.spec.ts`. Keep both in sync.
 */

/**
 * LinkedIn's company types, which Coresignal returns as `type` and older
 * enrichments stored as the legal form. None is a legal form.
 */
const LINKEDIN_COMPANY_TYPES = new Set([
  "educational",
  "government agency",
  "nonprofit",
  "partnership",
  "privately held",
  "public company",
  "self-employed",
  "self-owned",
]);

/** The legal form worth showing: none for a LinkedIn company type. */
export function displayableLegalForm(
  legalForm: string | null | undefined,
): string | null {
  const value = legalForm?.trim();
  if (!value || LINKEDIN_COMPANY_TYPES.has(value.toLowerCase())) return null;
  return value;
}
